const ITEMS = [
  "ENGINEERED IN TOKYO",
  "★",
  "40–99 LB TENSION",
  "★",
  "5 RESISTANCE KNOBS",
  "★",
  "ADJUSTABLE IN SECONDS",
  "★",
  "SHIPS WORLDWIDE",
  "★",
  "SERIES II — 2026",
  "★",
];

const Marquee = () => {
  const all = [...ITEMS, ...ITEMS];
  return (
    <section className="border-y border-white/10 overflow-hidden py-6 bg-[#0c0c0c]" data-testid="marquee">
      <div className="marquee flex whitespace-nowrap gap-12">
        {all.map((t, i) => (
          <span key={i} className={`font-heading text-2xl tracking-[0.15em] ${t === "★" ? "text-[#007AFF]" : "text-white/60"}`}>
            {t}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
